/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationDto } from '../../models/organization-dto';
import { UpdateOrganizationRequest } from '../../models/update-organization-request';

export interface OrganizationsOrganizationIdPut$Plain$Params {
  organizationId: string;
      body?: UpdateOrganizationRequest
}

export function organizationsOrganizationIdPut$Plain(http: HttpClient, rootUrl: string, params: OrganizationsOrganizationIdPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationDto>> {
  const rb = new RequestBuilder(rootUrl, organizationsOrganizationIdPut$Plain.PATH, 'put');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrganizationDto>;
    })
  );
}

organizationsOrganizationIdPut$Plain.PATH = '/organizations/{organizationId}';
